import { Component, OnInit } from '@angular/core';
import { GLOBAL } from "../../services/GLOBAL";
import { PromoService } from '../../services/promo.service';


@Component({
  selector: 'app-promos',
  templateUrl: './promos.component.html',
  styleUrls: ['./promos.component.css']
})
export class PromosComponent implements OnInit {

  public promos: Array<any> = [];
  public url;
  public isPromosLoading = true;
  public placeholderCards = [1, 2, 3, 4, 5, 6];
  public promoMediaLoaded: { [id: string]: boolean } = {};


  public global = GLOBAL;

  constructor(
    private _promoService: PromoService
  ) {
    this.url = GLOBAL.url;
  }

  ngOnInit(): void {
    this.initData();
  }

  initData() {
    this.isPromosLoading = true;

    this._promoService.listar().subscribe(
      response => {
        this.promos = response.promos || [];
        this.promoMediaLoaded = {};
        this.promos.forEach(item => {
          const mediaKey = item && (item._id || item.poster);
          if (mediaKey) {
            this.promoMediaLoaded[mediaKey] = false;
          }
        });
        this.isPromosLoading = false;
      },
      error => {
        this.isPromosLoading = false;
      }
    );
  }

  isPromoLoaded(id: any): boolean {
    return !!this.promoMediaLoaded[id];
  }

  onPromoMediaLoaded(id: any): void {
    if (!id) {
      return;
    }
    this.promoMediaLoaded[id] = true;
  }

  ngAfterViewInit() {
    const images = document.querySelectorAll<HTMLImageElement>('img[data-enlargable]');

    Array.from(images).forEach((img) => {
      img.classList.add('img-enlargable');
      img.addEventListener('click', function () {
        const src = this.getAttribute('data-src-lg');
        const overlay = document.createElement('div');
        overlay.style.background = `RGBA(0,0,0,.5) url(${src}) no-repeat center`;
        overlay.style.backgroundSize = 'contain';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.position = 'fixed';
        overlay.style.zIndex = '10000';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.cursor = 'zoom-out';

        overlay.addEventListener('click', function () {
          document.body.removeChild(this);
        });

        document.body.appendChild(overlay);
      });
    });


  }


}
